"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { styled } from '../../styled-system/jsx/factory.mjs';
import '../../styled-system/jsx/is-valid-prop.mjs';
import 'react';
import '../../styled-system/helpers.mjs';
import '../../styled-system/css/css.mjs';
import '../../styled-system/patterns/visually-hidden.mjs';
import '../../styled-system/css/conditions.mjs';
import { text } from '../../styled-system/recipes/text.mjs';

const Text = styled("p", text);

export { Text };
